import { css } from '@/styled-system/css';

export const inputChipIconStyles = css.raw({
  color: 'icon.neutral',
  marginInlineEnd: 'tighter',
});
